import React from "react";
import Lottie from "react-lottie";
import styled from "styled-components";
import animation from "../../assets/animations/loading.json";

const LoadingWrapper = styled.div`
  min-height: 200px;
  display: flex;
  align-content: center;
  justify-content: center;
`;

const getAnimationOptions = (animation) => ({
  loop: true,
  autoplay: true,
  animationData: animation,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
});

const getAnimationSize = () => 200;

const Loading = ({ message }) => (
  <LoadingWrapper>
    <Lottie
      options={getAnimationOptions(animation)}
      height={getAnimationSize()}
      width={getAnimationSize()}
    />
  </LoadingWrapper>
);

export default Loading;
